import { supabase } from '../supabaseClient';
import { effJiraKey } from '../utils/jira';

/* Accès aux données « jira-sync ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function importTimesheet(row) {
  return supabase.functions.invoke('jira-sync', {
    body: { insertTimesheets: [row] },
  });
}

export function importTimesheets(rows) {
  return supabase.functions.invoke('jira-sync', {
    body: { insertTimesheets: rows },
  });
}

export function listJiraEpics(client, phase) {
  return supabase.functions.invoke('jira-sync', {
    body: { listEpicsForProject: effJiraKey(phase, client) },
  });
}

export function fetchEpicMonthBreakdown(month, projectKey) {
  return supabase.functions.invoke('jira-sync', {
    body: { epicMonthBreakdown: { projectKey, month } },
  });
}

export function runFullJiraSync(fromMonth, projectKey, toMonth) {
  return supabase.functions.invoke('jira-sync', {
    body: { fullSync: { projectKeys: [projectKey], fromMonth, toMonth } },
  });
}

export function importLogTimesheet(briqueId, log, user) {
  return supabase.functions.invoke('jira-sync', {
    body: {
      insertTimesheets: [
        {
          user_id: user.id,
          dev_id: user.dev_id || user.id,
          date: log.worklog_date,
          brique_id: briqueId,
          heures: log.hours,
          note: 'Import Jira (manuel)',
        },
      ],
    },
  });
}

export function fetchHoursByLabel(fromDate, label, projKey, toDate) {
  return supabase.functions.invoke('jira-sync', {
    body: { fetchHoursByLabel: { projectKey: projKey, label, fromDate, toDate } },
  });
}

export function runJiraSync(epicKeys, projectKeys) {
  return supabase.functions.invoke('jira-sync', {
    body: { epicKeys, projectKeys },
  });
}

export function listWorklogAuthors(projectKeys) {
  return supabase.functions.invoke('jira-sync', {
    body: { listWorklogAuthors: { projectKeys } },
  });
}

export function fetchDayWorklogs(payload) {
  return supabase.functions.invoke('jira-sync', {
    body: { worklogsForDay: payload },
  });
}

export function pushEpicSoldDays(epicKey, days) {
  return supabase.functions.invoke('jira-sync', {
    body: { pushSoldDays: { epicKey, days } },
  });
}
